import React from 'react'
import { EditButton, Show, TopToolbar, useResourceContext, WithRecord } from 'react-admin'

import { SYSTEM_PERMISSION_READ, SYSTEM_PERMISSION_UPDATE } from '../config/permissions'
import { useResourcePermissions } from '../domain/permissions'
import { ListReference } from '../resources/common/list'
import { Title } from '../resources/common/show'
import eventsConfig from '../resources/events/config'
import { EventsListLayout } from '../resources/events/list'

const ShowActions = () => {
  const resource = useResourceContext()
  const [hasEdit] = useResourcePermissions(resource, SYSTEM_PERMISSION_UPDATE)
  return <TopToolbar>{hasEdit && <WithRecord render={(record) => !record?.deleted_on && <EditButton />} />}</TopToolbar>
}
const AdvancedShow = ({ children, aside, disableEventsAside = false, ...props }) => {
  const [hasReadForEvents] = useResourcePermissions(eventsConfig.name, SYSTEM_PERMISSION_READ)
  return (
    <Show
      actions={<ShowActions />}
      title={<Title />}
      aside={
        <>
          {aside}
          {!disableEventsAside && hasReadForEvents && (
            <ListReference reference={eventsConfig.name} target="entity_id" sort={eventsConfig.options.defaultSort}>
              <EventsListLayout excludedFields={['entity_id']} />
            </ListReference>
          )}
        </>
      }
      emptyWhileLoading
      {...props}
    >
      {children}
    </Show>
  )
}

export default AdvancedShow
